import { HomePageSearchPart } from "./Componenets/HomePageSearchPart";
import React from "react";
import SlideShow from "./Componenets/SlideShow";
import JobCarousel from "./Componenets/JobCarousel";
import QuickSearchComponent from "./Componenets/QuickSearches";
import JobListingDeneme from "./Componenets/JobListingDeneme";
import FAQComponent from "./Componenets/Faq";

const HomePage = () => {
  return (
    <>
      <HomePageSearchPart />
      <QuickSearchComponent />
      <SlideShow />
      {/* <JobCarousel /> */}
      <JobListingDeneme />
      <FAQComponent />
    </>
  );
};

export default HomePage;
